import { Component, OnInit } from '@angular/core';
import { Accessory } from "../../../shared/model/accessory";
import { AccessoryService } from "../../../shared/service/accessory.service";
import { AccessoryAmountService } from "../../../shared/service/accessory-amount.service";
import { ToastService } from "../../../shared/service/toast.service";
import { AccessoryAmount } from "../../../shared/model/accessory-amount";
import { Router } from "@angular/router";

@Component({
  selector: 'tx-accessory-create',
  templateUrl: './accessory-create.component.html',
  styleUrls: ['./accessory-create.component.css']
})
export class AccessoryCreateComponent implements OnInit {
  selectedAccessory: Accessory;
  quantity: number;
  accessories: Array<Accessory>;
  accessoryAttributesTree = ['name'];

  constructor(private _accessoryService: AccessoryService, private _accessoryAmountService: AccessoryAmountService,
              private _toastService: ToastService, private _router: Router) {
  }

  ngOnInit() {
    this.setUpEmptyEntities();
    this.findAccessories();
  }

  selectAccessory(accessory) {
    if (this.selectedAccessory === accessory) {
      this.selectedAccessory = null;
    } else {
      this.selectedAccessory = accessory;
    }
  }

  save() {
    if (this.quantity && this.selectedAccessory) {
      this._accessoryAmountService.save(new AccessoryAmount(null, this.quantity, null, this.selectedAccessory));
      this.cleanEntities();
    }
  }

  goBack() {
    this._router.navigate(['accessories']);
  }

  private setUpEmptyEntities() {
    this.accessories = new Array();
    this.quantity = null;
  }

  private findAccessories() {
    this._accessoryService.getAccessoryTypes()
      .subscribe(
        accessories => this.accessories = accessories,
        error => this.showMessage(error.text)
      );
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

  private cleanEntities() {
    this.selectedAccessory = null;
    this.quantity = null;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/accessory/component/accessory-create/accessory-create.component.ts